"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwimLane = void 0;
var _react = require("react");
var _hooks = require("../../hooks");
var _ArrowButton = require("./partials/ArrowButton");
var _SwimLane = require("./SwimLane.labels");
var _SwimLane2 = _interopRequireDefault(require("./SwimLane.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SwimLane = props => {
  const {
    items = [],
    maxNumberOfItems,
    slideBy = 'item'
  } = props;
  const itemsToDisplay = (0, _react.useMemo)(() => !maxNumberOfItems || maxNumberOfItems > items.length ? items : items.slice(0, maxNumberOfItems), [items, maxNumberOfItems]);
  const containerRef = (0, _react.useRef)(null);
  const innerContainerRef = (0, _react.useRef)(null);
  const isMoving = (0, _react.useRef)();
  const [swimLaneDirection, setSwimLaneDirection] = (0, _react.useState)();
  const [isLeftButtonVisible, setIsLeftButtonVisible] = (0, _react.useState)(false);
  const [isRightButtonVisible, setIsRightButtonVisible] = (0, _react.useState)(false);
  const [translateX, setTranslateX] = (0, _react.useState)(0);
  const [translateDelta, setTranslateDelta] = (0, _react.useState)(0);
  const getLabel = (0, _hooks.useLabels)({
    labels: _SwimLane.labels
  });
  const styles = (0, _SwimLane2.default)(slideBy);
  const calcItemWidth = (0, _react.useCallback)(() => {
    if (innerContainerRef.current?.children?.length) {
      const firstChild = innerContainerRef.current.firstElementChild;
      if (firstChild) {
        const boundingClientRect = firstChild.getBoundingClientRect();
        const innerBoundingClientRect = firstChild.firstElementChild?.getBoundingClientRect();
        return {
          totalWidth: boundingClientRect.width,
          innerWidth: innerBoundingClientRect ? innerBoundingClientRect.width : boundingClientRect.width,
          margin: innerBoundingClientRect?.width ? boundingClientRect.width - innerBoundingClientRect.width : 0
        };
      }
    }
    return undefined;
  }, []);
  const handleMoveLeft = () => {
    if (isMoving.current) return;
    if (swimLaneDirection && containerRef.current && innerContainerRef.current?.firstElementChild && innerContainerRef.current?.lastElementChild) {
      const currentLeft = containerRef.current.getBoundingClientRect().left;
      const minLeft = swimLaneDirection === 'ltr' ? innerContainerRef.current.firstElementChild.getBoundingClientRect().left : innerContainerRef.current.lastElementChild.getBoundingClientRect().left;
      const newTranslateVal = translateX + translateDelta;
      if (minLeft <= currentLeft) {
        isMoving.current = true;
        setTranslateX(newTranslateVal);
        setIsRightButtonVisible(true);
        setIsLeftButtonVisible(Math.round(minLeft + translateDelta) < Math.round(currentLeft));
      } else {
        setIsLeftButtonVisible(false);
      }
    }
  };
  const handleMoveRight = () => {
    if (isMoving.current) return;
    if (swimLaneDirection && containerRef.current && innerContainerRef.current?.firstElementChild && innerContainerRef.current?.lastElementChild) {
      const currentRight = containerRef.current.getBoundingClientRect().right;
      const maxRight = swimLaneDirection === 'ltr' ? innerContainerRef.current.lastElementChild.getBoundingClientRect().right : innerContainerRef.current.firstElementChild.getBoundingClientRect().right;
      const newTranslateVal = translateX - translateDelta;
      if (currentRight <= maxRight) {
        isMoving.current = true;
        setTranslateX(newTranslateVal);
        setIsLeftButtonVisible(true);
        setIsRightButtonVisible(Math.round(currentRight + translateDelta) < Math.round(maxRight));
      } else {
        setIsRightButtonVisible(false);
      }
    }
  };
  (0, _react.useEffect)(() => {
    if (slideBy === 'scroll') {
      setIsLeftButtonVisible(false);
      setIsRightButtonVisible(false);
      setTranslateX(0);
    } else {
      const itemWidth = calcItemWidth();
      if (itemWidth?.totalWidth && itemsToDisplay.length > 0 && containerRef.current && innerContainerRef.current) {
        const computedStyle = window.getComputedStyle(containerRef.current);
        const containerWidth = Number(computedStyle.width.replace('px', ''));
        const contentWidth = itemWidth.totalWidth * itemsToDisplay.length;
        if (slideBy === 'item') {
          setTranslateDelta(contentWidth <= containerWidth ? 0 : itemWidth.totalWidth);
        } else if (slideBy === 'page') {
          setTranslateDelta(contentWidth <= containerWidth ? 0 : containerWidth);
        }
        const lastItemElement = innerContainerRef.current?.lastElementChild;
        if (lastItemElement) {
          if (computedStyle.direction !== 'ltr') {
            const containerLeft = containerRef.current.getBoundingClientRect().left;
            const lastItemLeft = lastItemElement.getBoundingClientRect().left;
            setIsLeftButtonVisible(lastItemLeft + itemWidth.margin < containerLeft - itemWidth.margin);
          } else {
            const containerRight = containerRef.current.getBoundingClientRect().right;
            const lastItemRight = lastItemElement.getBoundingClientRect().right;
            setIsRightButtonVisible(lastItemRight > containerRight);
          }
        }
        setSwimLaneDirection(computedStyle.direction);
      }
    }
  }, [slideBy, itemsToDisplay.length, containerRef, innerContainerRef, calcItemWidth]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: containerRef,
    className: styles['cc-SwimLane'],
    children: itemsToDisplay?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [isLeftButtonVisible && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowButton.ArrowButton, {
        direction: "left",
        label: swimLaneDirection === 'ltr' ? getLabel('previous') : getLabel('next'),
        onClick: handleMoveLeft
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ref: innerContainerRef,
        className: styles['cc-SwimLane__items'],
        onTransitionEnd: () => {
          isMoving.current = false;
        },
        style: {
          transform: `translateX(${translateX}px)`
        },
        children: itemsToDisplay.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-SwimLane__item'],
          children: item
        }, index))
      }), isRightButtonVisible && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowButton.ArrowButton, {
        direction: "right",
        label: swimLaneDirection === 'ltr' ? getLabel('next') : getLabel('previous'),
        onClick: handleMoveRight
      })]
    })
  });
};
exports.SwimLane = SwimLane;